var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiversify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H176C189.255 0 200 10.7452 200 24V196C200 209.255 189.255 220 176 220H24C10.7452 220 0 209.255 0 196V24Z",
    fill: "#5091BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62.5C80 61.1193 81.1193 60 82.5 60H147.5C148.881 60 150 61.1193 150 62.5V67.5C150 68.8807 148.881 70 147.5 70H82.5C81.1193 70 80 68.8807 80 67.5V62.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 82.5C65 81.1193 66.1193 80 67.5 80H132.5C133.881 80 135 81.1193 135 82.5V87.5C135 88.8807 133.881 90 132.5 90H67.5C66.1193 90 65 88.8807 65 87.5V82.5ZM75 102.5C75 101.119 76.1193 100 77.5 100H117.5C118.881 100 120 101.119 120 102.5V107.5C120 108.881 118.881 110 117.5 110H77.5C76.1193 110 75 108.881 75 107.5V102.5ZM92.5 120C91.1193 120 90 121.119 90 122.5V127.5C90 128.881 91.1193 130 92.5 130H127.5C128.881 130 130 128.881 130 127.5V122.5C130 121.119 128.881 120 127.5 120H92.5ZM95 142.5C95 141.119 96.1193 140 97.5 140H117.5C118.881 140 120 141.119 120 142.5V147.5C120 148.881 118.881 150 117.5 150H97.5C96.1193 150 95 148.881 95 147.5V142.5ZM92.5 155C91.1193 155 90 156.119 90 157.5V162.5C90 163.881 91.1193 165 92.5 165H102.5C103.881 165 105 163.881 105 162.5V157.5C105 156.119 103.881 155 102.5 155H92.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversify);
export default __webpack_public_path__ + "static/media/diversify.4b29d5a6.svg";
export { ForwardRef as ReactComponent };